import { getRegion, CountryMap } from '@/utils/locale'
const country = CountryMap.includes(getRegion()) ? getRegion() : ''

export const getCountry =
  country || JSON.parse(window?.localStorage?.getItem('countryCode')) || 'MX'
